import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { apiCall } from '../api/client';

export default function ContractorProfile() {
  const { id } = useParams();
  const { data, isLoading } = useQuery({ queryKey: ['contractor', id], queryFn: () => apiCall<any>(`/contractors/${id}`) });
  const { data: reviews } = useQuery({ queryKey: ['reviews', id], queryFn: () => apiCall<any[]>(`/reviews/contractor/${id}`) });

  if (isLoading) return <div className="page"><div className="doe-spinner" style={{ margin: '48px auto' }} /></div>;
  const c = data?.data;
  if (!c) return <div className="page"><p>Contractor not found</p></div>;

  return (
    <div className="page" style={{ maxWidth: 640, margin: '0 auto' }}>
      <div className="card" style={{ textAlign: 'center', marginBottom: 'var(--space-xl)' }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'var(--color-tan)', margin: '0 auto var(--space-md)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
          {c.display_name?.[0] || '?'}
        </div>
        <h1 style={{ fontSize: '1.4rem', fontWeight: 700 }}>{c.business_name}</h1>
        <p style={{ opacity: 0.7 }}>{c.display_name}</p>
        <div style={{ display: 'flex', gap: 'var(--space-md)', justifyContent: 'center', marginTop: 'var(--space-md)' }}>
          <span className="chip">{c.trade_icon} {c.trade_name}</span>
          <span className="chip">📍 {c.grazing_territory_miles}mi range</span>
          {c.years_experience && <span className="chip">{c.years_experience}yr exp</span>}
        </div>
        <div className="stars" style={{ justifyContent: 'center', marginTop: 'var(--space-md)', fontSize: '1.2rem' }}>
          {'★'.repeat(Math.round(c.avg_rating || 0))}{'☆'.repeat(5 - Math.round(c.avg_rating || 0))}
          <span style={{ fontSize: '0.9rem', opacity: 0.6, marginLeft: 8 }}>({c.total_reviews} reviews)</span>
        </div>
        {c.bio && <p style={{ marginTop: 'var(--space-md)', opacity: 0.8 }}>{c.bio}</p>}
      </div>

      <h2 style={{ fontWeight: 600, marginBottom: 'var(--space-md)' }}>Reviews</h2>
      {(reviews?.data || []).map((r: any) => (
        <div key={r.id} className="card" style={{ marginBottom: 'var(--space-sm)' }}>
          <div className="stars" style={{ marginBottom: 4 }}>{'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}</div>
          {r.text && <p style={{ fontSize: '0.9rem' }}>{r.text}</p>}
          <p style={{ fontSize: '0.75rem', opacity: 0.5, marginTop: 4 }}>{r.reviewer_name} · {new Date(r.created_at * 1000).toLocaleDateString()}</p>
        </div>
      ))}
    </div>
  );
}
